import {translations} from "Smt/translations";
import {withTranslation} from "@sirius/ui-lib/src/blocks/LocaleBlock/WithTranslation";
import {DocumentTitleLocalized} from "./DocumentTitleLocalized";

const DocumentTitleLocale = withTranslation(DocumentTitleLocalized, translations);

export {DocumentTitleLocale};
